import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WINDOW } from 'app/services/window.provider';

@Injectable({
  providedIn: 'root'
})
export class TempleService {
  host: string;
  constructor(private http: HttpClient, @Inject(WINDOW) private window: Window) { }
  allTemple(): Observable<any> {
    this.host = this.window.location.hostname;
    return this.http.get<any>(`all`);
  }
}
